import React from "react";
import { NavLink } from "react-router-dom";
import ReactPlayer from "react-player";

var bgimg1 =
  "https://theme7x.com/react/inteshape/static/media/6.ab9e0b39f4b67e7c7763.jpg";
var bgimg2 = require("../../images/video-img.jpg");

class Statistics1 extends React.Component {
  render() {
    return (
      <>
        <div className="container-fluid p-t50">
          <div className="section-content">
            {/* TITLE START */}
            <div
              data-aos-duration="800"
              data-aos="fade-up"
              className="section-head"
            >
              <div className="sx-separator-outer separator-center p-0">
                <div className="sx-separator  bg-white bg-moving bg-repeat-x">
                  <h3 className="sep-line-one">
                    Projet Vallée Val d'Or I - Vidéo
                  </h3>
                </div>
              </div>
            </div>
            {/* TITLE END */}
          </div>
        </div>

        <div
          className="video3-section section-full overlay-wraper sx-bg-secondry mobile-page-padding bg-parallax ml-auto"
          // data-stellar-background-ratio="0.5"
          style={{
            backgroundImage: "url(" + bgimg2 + ")",
            padding: "220px 0px 220px",
            backgroundSize: "cover",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "inherit",
            backgroundPosition: "center",
          }}
        >
          {/* <div className="overlay-main bg-black opacity-04" /> */}
          {/* <NavLink
            className="get-in-touch-btn from-top"
            data-aos-duration="800"  data-aos="fade-left"
            // onClick={this.handleQuoteToggle}
          >
            <span className="ml-2">Discover our projects</span>
          </NavLink> */}
          <div className="container">
            <div className="row">
              <div className="col-xl-12">
                <div className="video-one__inner">
                  {/* <div data-aos-duration="800"  data-aos="fade-up" className="text-box">
                    <h2>Discover our projects</h2>
                  </div> */}
                  <div className="video-box">
                    <a
                      href="https://www.youtube.com/watch?v=Get7rqXYrbQ"
                      className="video-popup"
                    >
                      <div className="video-one__icon">
                        <NavLink
                          to={"#"}
                          className="play-now"
                          data-toggle="modal"
                          data-target="#myModal"
                        >
                          <i className="icon fa fa-play" />
                          <span className="ripple" />
                        </NavLink>
                      </div>
                    </a>
                    {/* <span className="border-animation border-1"></span>
                    <span className="border-animation border-2"></span>
                    <span className="border-animation border-3"></span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade" id="myModal" role="dialog">
            <div className="modal-dialog">
              <div className="modal-content">
                <ReactPlayer
                  controls={true}
                  url={require("../../videos/vallee-1er.mp4")}
                />
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Statistics1;
